import React, { Component } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { Separator } from "../../../components/common/CustomBootstrap";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames],
    );
  };

  render() {
    const { dropdownSplitOpen } = this.state;
    const { item } = this.props;

    // Kiểm tra có phải role mặc định không
    const isDefaultRole =
      item.pending_cashier ||
      item.pending_table_payment ||
      item.pending_kitchen;

    // Label badge cho từng loại
    const defaultLabel = item.pending_table_payment ? (
      <IntlMessages id="role.default.table-pending-payment" />
    ) : item.pending_cashier ? (
      <IntlMessages id="role.default.cashier" />
    ) : item.pending_kitchen ? (
      <IntlMessages id="role.default.kitchen" />
    ) : null;

    const cardStyle = isDefaultRole
      ? {
          // borderLeft: "4px solid #145388",
          backgroundColor: "#f0f5fb",
        }
      : {};

    return (
      <Card className="mb-3 custom-shadow" style={cardStyle}>
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            {item.at ? (
              <div
                onClick={() => this.onClickedItem(item)}
                className={classnames(
                  "card-body align-self-center d-flex flex-ssm-column justify-content-between min-width-zero",
                  {
                    "flex-lg-row align-items-lg-center":
                      !this.props.setting?.update,
                  },
                )}
              >
                <div className="w-50 list-item-heading mb-1 truncate d-block w-sm-100">
                  <span style={isDefaultRole ? { fontWeight: 700 } : {}}>
                    {item.name}
                  </span>
                </div>
                <div className="w-50 d-flex align-items-center">
                  <Badge color={"primary"} pill>
                    {item.at}
                  </Badge>
                  {defaultLabel && (
                    <Badge
                      color="secondary"
                      pill
                      style={{
                        marginLeft: 6,
                        fontSize: "0.72rem",
                        opacity: 0.8,
                      }}
                    >
                      {defaultLabel}
                    </Badge>
                  )}
                </div>
              </div>
            ) : (
              <div
                onClick={() => this.onClickedItem(item)}
                className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center"
              >
                <div className="list-item-heading mb-1 truncate d-block">
                  <span style={isDefaultRole ? { fontWeight: 700 } : {}}>
                    {item.name}
                  </span>
                  {defaultLabel && (
                    <Badge
                      color="primary"
                      pill
                      style={{
                        marginLeft: 8,
                        fontSize: "0.72rem",
                        opacity: 0.85,
                      }}
                    >
                      {defaultLabel}
                    </Badge>
                  )}
                </div>
              </div>
            )}
            {/* Simple Checkbox - for multi-select */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.props.onChangeCheckbox(item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-role-${item.id}`}
                label=""
                checked={this.props.selectedItems.includes(item.id)}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
